import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useAdminStore } from '@getmayday/vue-modules';

export default (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const adminStore = useAdminStore();

  const authorizedSession = !!adminStore.accessToken;
  if (
    to.matched.some((record) => record.meta.authorize) &&
    !authorizedSession
  ) {
    return next({ name: 'login' });
  }

  next();
};
